import {BaseControl} from './base-control';
import {RadioGroupOptionInterface} from '../../components';

import {RadioGroupControlInterface} from '../../interfaces';

export class RadioGroupControl extends BaseControl {
    public options: RadioGroupOptionInterface[];

    constructor(data: RadioGroupControlInterface) {
        super(data);

        this.options = data.options;
    }

    getOption(value: string | number): RadioGroupOptionInterface {
        const filteredOptions = this.options.filter((option: RadioGroupOptionInterface) => option.value === value);

        if (filteredOptions.length > 0) {
            return filteredOptions[0];
        }

        return null;
    }
}
